import addDays from 'date-fns/addDays';
import { z } from 'zod';

import { DynamicArtifactTemplate } from '@eluve/llm-outputs';

import { AppointmentModel } from '../../models/appointment';
import { ChartType } from '../../models/chart';
import { PatientType } from '../../models/patient';
import {
  PatientEhrUrlArgs,
  VendorDataMapper,
  VendorSyncConfig,
} from '../vendor-data-mapper';

import { logo } from './logo';

export class BlvdVendorDataMapper implements VendorDataMapper {
  getAppointments(data: unknown): AppointmentModel[] {
    throw new Error('Not implemented');
  }

  getPatient(data: unknown): PatientType | null {
    throw new Error('Not implemented');
  }

  getPatientEhrUrl({ domain, externalPatientId }: PatientEhrUrlArgs): string {
    return `https://${domain}/clients/${externalPatientId?.replaceAll('urn:blvd:Client:', '')}`;
  }

  getLogo = () => logo;

  getHomeUrl(domain: string): string {
    return `https://${domain}`;
  }

  getChart(
    data: unknown,
    additionalFields?: Record<string, unknown>,
  ): ChartType {
    throw new Error('Not implemented');
  }

  convertChartToSummary = ({
    data,
    template,
  }: {
    data: unknown;
    template: DynamicArtifactTemplate;
  }) => {
    return null;
  };

  getSyncConfig(): VendorSyncConfig {
    return {
      isImportEnabled: true,
      isSyncEnabled: false,
      canSignNoteInEhr: false,
      canSyncWithManualChartUrl: false,
      shouldDisplayConfirmationBeforeSync: true,
      syncStartDate: new Date(),
      syncEndDate: addDays(new Date(), 2),
      canSyncNoteToEhr: () => ({ canSync: false }),
    };
  }

  getVendorSchema = () => {
    const secretSchema = z.object({
      'API Key': z.string(),
      'Key Secret': z.string(),
      'Business ID': z.string(),
    });
    const plainTextSchema = z.object({
      'Legacy EHR ID Prefix': z.string().optional(),
      'Legacy External EHR ID': z.string().optional(),
    });
    return { secretSchema, plainTextSchema };
  };
}
